import { Injectable, NgZone} from '@angular/core';
import { CustomService } from './custom.service';
import { StateService } from './state.service';
import * as $ from "jquery";

@Injectable({
  providedIn: 'root'
})
export class AppService {

  public browser_info="";
  public orientation = 'landscape';
  public licenseId = "";
  public documentId="";

  public currentAudioId;
  public currentAudio = 0;
  public jplayerAudioId:any;
  public audioPlayerElement:any;
  public seekTime:any;
  public sec:any;
  public min:any;



  public listofpopupopen ="#clickarea1,\
  #clickarea2,\
  #clickarea3,\
  #clickarea4,\
  #clickarea5,\
  .fk_rbex_submenu";

  public listofpopupclose =
  "#fk_closebtn,\
  .closebutton1,\
  .closebutton2,\
  .closebutton3,\
  .closebutton4,\
  .closebutton5";



  public mouseclick = 0;

  constructor(public stateService: StateService, public customService: CustomService)
  {
    this.browser_info=customService.findBrowser();
    this.appInit();
  }


  loadEvents(event, eventname) {
    let id_value = event.currentTarget.id;
    let currentTarget = event.currentTarget;
    if (eventname == "click") {
      if (this.customService.elHasClass(currentTarget, "tick")) {
        this.customService.clickToggleClass(currentTarget, 'ticked');
      }
      else if (this.customService.elHasClass(currentTarget, "label") || this.customService.elHasClass(currentTarget, "label_img")) {
        this.seekTime = $(this).data('seektimestart');

        var repeatSeekTime = $(this).data('repeattimestart');
        if (repeatSeekTime && repeatSeekTime < this.audioPlayerElement.currentTime) {
          this.audioPlayerElement.currentTime = ($(this).data('rhymes') != null) ? parseInt(repeatSeekTime) + 0.9 : repeatSeekTime;
        } else {
          this.audioPlayerElement.currentTime = ($(this).data('rhymes') != null) ? parseInt(this.seekTime) + 0.9 : this.seekTime;
        }

      }

      else if (this.customService.elHasClass(currentTarget, "LearnNew_Words") || this.customService.elHasClass(currentTarget, "LearnNew_Rap")) {
       
      }
      else if (id_value == "resetBtn") {
        this.resetForm();
      }
      else if (id_value == "audio") {
        this.highlightText();
        this.highlightTextTime();
      }
    }
    else if (eventname == "mouseenter")
    {
      if (this.customService.elHasClass(currentTarget, "fk_rbex_submenu") || id_value =="fk_rbex_label") {
        this.mouseclick = 0;
        this.customService.addClass("#mainContent", "popup_open");
      }
    }
    else if (eventname == "mouseleave")
    {
      if (this.customService.elHasClass(currentTarget, "fk_rbex_submenu") || id_value == "fk_rbex_label") {
        if (this.mouseclick != 1) {
          this.customService.removeClass("#mainContent", "popup_open");
        }
      }
    }
    else if (eventname == "keyup") {
      if (this.customService.elHasClass(currentTarget, "jump")) {
        if (currentTarget.value.length == currentTarget.getAttribute('maxlength')) {
          var ntabindex = parseInt(currentTarget.getAttribute('tabindex'));
          ntabindex++;          
          var ntabindexel: any = document.querySelectorAll('[tabindex = ' + ntabindex + ']');
          ntabindexel.focus();
        }
      }
    }



  }

appInit()
{
  let thisme:any=this;

    var c_document:any=document;
    var documentMode=c_document.documentMode;

   if (this.browser_info=="IE") {
     this.customService.addClass("html","ie");
     this.customService.addClass("html","ie" + documentMode);    
  }
  else if (this.browser_info=="Edge") {
    this.customService.addClass("html","ie");
    this.customService.addClass("html","ieedge");
  }
  else if (this.browser_info=="Safari") {
    this.customService.addClass("html","safari");
    this.customService.addClass("html",this.customService.isiPhone());
  }

  this.setOrientation();

  this.documentId = $('body').data('id');
  this.licenseId = this.stateService.getLicenseId();


  this.loadDocumentData();  

  this.jplayerAudioId = $("#jquery_jplayer_1 audio")[0] ? $("#jquery_jplayer_1 audio")[0].id : '';
  this.audioPlayerElement =this.getElementById(this.jplayerAudioId);

  this.set_interval();  

  $(document).on('loadComplete', function(e, IDR) {
      IDR.handleZoom();
  });

}

set_interval() {
  let thisme=this;
    setInterval(function() {
        thisme.highlightText();
        thisme.highlightTextTime();
    }, 200);
  }
  

highlightTextTime() {

    if (this.audioPlayerElement != null) {
        let sec:any = Math.floor(this.audioPlayerElement.currentTime);
        let min:any = Math.floor(sec / 60);
        min = min >= 10 ? min : '0' + min;
        sec = Math.floor(sec % 60);
        sec = sec >= 10 ? sec : '0' + sec;
        $("#jplayer_total_time").html(min + ":" + sec);

        if (this.audioPlayerElement.duration == this.audioPlayerElement.currentTime) {
            this.audioPlayerElement.pause();
            this.audioPlayerElement.currentTime = 0;
            $("#jplayer_total_time").html("00:00");
        }
    }
}


resetForm() {
    $('input[type=text]').each(function(i, e) {
        $(e).val('');
    });
    $('textarea').each(function(i, e) {
        $(e).val('');
    });
    $('input[type=checkbox').each(function(i, e) {
        $(e).prop('checked', false);
    });
}

getElementById(seletor) {
  let data_element:any=document.getElementById(seletor);
  return data_element;
}


loadDocumentData() {
  if(this.licenseId && this.licenseId!="")
  {
    var licenseId=this.licenseId;
    var documentId=this.documentId;
    $('input[type=text]').each(function(i, e) {
        var storedValue = localStorage.getItem(licenseId + 'document' + documentId + '-' + $(e).attr('id'));
        $(e).val(storedValue);
    });
    $('textarea').each(function(i, e) {
        var storedValue = localStorage.getItem(licenseId + 'document' + documentId + '-' + $(e).attr('id'));
        $(e).val(storedValue);
    });
  }
}

storeDocumentData(event) {
  if(this.licenseId && this.licenseId!="")
  {
    var licenseId=this.licenseId;
    var documentId=this.documentId;

      $('input[type=text]').each(function(i, e) {
          localStorage.setItem(licenseId + 'document' + documentId + '-' + $(e).attr('id'), $(e).val());
      });
      $('textarea').each(function(i, e) {
          localStorage.setItem(licenseId + 'document' + documentId + '-' + $(e).attr('id'), $(e).val());
      });
      $('input[type=checkbox').each(function(i, e) {
          localStorage.setItem(licenseId + 'document' + documentId + '-' + $(e).attr('id'), $(e).prop('checked'));
      });
  }
}

setOrientation() {
   this.orientation = window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
}
detectIPadOrientation(appService,orientationAngle) {
  var orientation="";
    if (orientationAngle == 0) {
        orientation = 'portrait';
    } else if (orientationAngle == 90) {
        orientation = 'landscape';
    } else if (orientationAngle == -90) {
        orientation = 'landscape';
    } else if (orientationAngle == 180) {
        orientation = 'portrait';
    }
    appService.orientation=orientation;
}

 playAudio(a) {

    this.currentAudioId = a.attributes.name.value;

    $("#jquery_jplayer_1").jPlayer({
        ready: function(event) {           
        },
        swfPath: "lib",
        volume: 100,
        supplied: "m4a, oga, mp3",
        wmode: "window",
        useStateClassSkin: true,
        autoBlur: false,
        smoothPlayBar: true,
        keyEnabled: true,
        remainingDuration: true,
        toggleDuration: true
    });

    let sec = new Number();
    let min = new Number();
    var id = a.id;

    this.customService.removeClass(".label","active");
    this.customService.removeClass(".label_img","active");

    this.audioOverlay(a.getAttribute('data-popupid'));
    this.audioPlayerElement = this.getElementById($("#jquery_jplayer_1 audio")[0].id);
    var randomId = '';
    if (this.browser_info=="IE") {
        randomId = "?id=" + Math.random();
    }
    $("#jquery_jplayer_1").jPlayer({
        supplied: "m4a, oga, mp3"
    }).jPlayer("setMedia", {
        mp3: a.getAttribute('data-audio-src') + ".mp3" + randomId,
        oga: a.getAttribute('data-audio-src') + ".ogg" + randomId
    });
    $("#jquery_jplayer_1").jPlayer("play", 0);

    if (a.getAttribute('data-audio-highlight')) {
        this.currentAudio = 1;
    } else {
        this.currentAudio = 0;
    }
    if (this.currentAudio == 1) {
        this.set_active();
    }

}

 set_active() {
   let thisme:any=this;
    setTimeout(function() {
        if (this.currentAudioId != 'circle' && this.currentAudioId != 'point') {
            thisme.customService.addClass(".label","active");
            thisme.customService.addClass(".label_img","active");           
        }
    }, 200);
}

highlightText() {

    var highlightsong = '.active.label';
    if (this.currentAudioId == 'circle') {
        highlightsong = '.label_circle';
    } else if (this.currentAudioId == 'point') {
        highlightsong = '.label_point';
    }


    this.resetHighlights();

    switch (this.currentAudio) {
        case 0:
            break;
        case 1:
            $.each($(highlightsong), function(index, val) {

                var val_className = val.className;
                if (this.audioPlayerElement.duration == this.audioPlayerElement.currentTime && val_className.indexOf("songText") > -1) {
                    var songLinecount = this.getElementById("txtbgColor");
                    songLinecount = songLinecount.getAttribute('data-seektimestart');

                    songLinecount = Number(songLinecount);

                    for (var i = 1; i <= songLinecount; i++) {
                        var linecount = this.getElementById("line_" + i);
                        linecount.style.display = "inline";
                        linecount.style.zIndex = 3;
                        var lineTop = linecount.getAttribute('data-top');
                        if (this.customService.isiPhone() === 'ipad') {

                            if (orientation == 0) {

                                lineTop = lineTop - 24.5;
                                lineTop = Number(lineTop);
                                if (i == 1) {
                                    linecount.style.top = lineTop + "%";
                                    linecount.style.color = "black";
                                    this.audioPlayerElement.pause();
                                    this.audioPlayerElement.currentTime = 0;
                                } else if (i == 2 || i == 3) {
                                    lineTop = lineTop + (7 * (i - 1));
                                    linecount.style.top = lineTop + "%";
                                    linecount.style.color = "#B2AFAD";
                                } else {
                                    linecount.style.zIndex = -1;
                                    linecount.style.color = "#B2AFAD";
                                }
                            } else {
                                
                                lineTop = Number(lineTop);
                                if (i == 1) {
                                    linecount.style.top = lineTop + "%";
                                    linecount.style.color = "black";
                                    this.audioPlayerElement.pause();
                                    this.audioPlayerElement.currentTime = 0;
                                } else if (i == 2 || i == 3) {
                                  
                                    lineTop = lineTop + (10 * (i - 1));
                                    linecount.style.top = lineTop + "%";
                                    linecount.style.color = "#B2AFAD";
                                } else {
                                    linecount.style.zIndex = -1;
                                    linecount.style.color = "#B2AFAD";
                                }
                            }

                        } else {

                            
                            lineTop = Number(lineTop);
                            if (i == 1) {
                                linecount.style.top = lineTop + "%";
                                linecount.style.color = "black";
                                this.audioPlayerElement.pause();
                                this.audioPlayerElement.currentTime = 0;
                            } else if (i == 2 || i == 3) {
                               
                                lineTop = lineTop + (10 * (i - 1));
                                linecount.style.top = lineTop + "%";
                                linecount.style.color = "#B2AFAD";
                            } else {
                                linecount.style.zIndex = -1;
                                linecount.style.color = "#B2AFAD";
                            }
                        }
                    }
                }

                if (this.audioPlayerElement.duration == this.audioPlayerElement.currentTime) {
                    this.audioPlayerElement.pause();
                    this.audioPlayerElement.currentTime = 0;
                }

                if (this.audioPlayerElement.currentTime > $(val).data('seektimestart') && this.audioPlayerElement.currentTime < $(val).data('seektimeend')) {

                    if (val_className.indexOf("songText") > -1) {
                        
                        this.customService.addClass(".songText","animated");
                        

                        var seektimestart = $(val).data('seektimestart');
                        var songLinecount = this.getElementById("txtbgColor");
                        songLinecount = songLinecount.getAttribute('data-seektimestart');
                        songLinecount = Number(songLinecount);
                        if (this.seektime != seektimestart) {
                            var lineId = val.id;
                            var splLineId = lineId.split('_');
                            var lineNumber = Number(splLineId[1]);

                            if (this.customService.isiPhone() === 'ipad') {

                                if (orientation == 0) {

                                    for (var lineCount = 1; lineCount <= songLinecount; lineCount++) {

                                        var line1 = this.getElementById("line_" + lineCount);
                                        line1.style.display = "inline";
                                        if (lineNumber == lineCount) {
                                            line1.style.zIndex = 3;
                                            line1.style.color = "black";
                                            var linetop = line1.getAttribute('data-top');
                                            linetop = Number(linetop);
                                            linetop = linetop - 24.5;
                                            line1.style.top = linetop + "%";
                                        } else if (lineNumber + 1 == lineCount) {
                                            line1.style.zIndex = 3;
                                            line1.style.color = "#B2AFAD";
                                            var linetop = line1.getAttribute('data-top');
                                            linetop = Number(linetop);
                                            linetop = linetop - 24.5;
                                            linetop = linetop + 7;
                                            line1.style.top = linetop + "%";
                                        } else if (lineNumber + 2 == lineCount) {
                                            line1.style.zIndex = 3;
                                            line1.style.color = "#B2AFAD";
                                            var linetop = line1.getAttribute('data-top');
                                            linetop = Number(linetop);
                                            linetop = linetop - 24.5;
                                            linetop = linetop + 14;
                                            line1.style.top = linetop + "%";
                                        } else if (lineNumber - 1 == lineCount) {
                                            line1.style.zIndex = 3;
                                            line1.style.color = "#B2AFAD";
                                            var linetop = line1.getAttribute('data-top');
                                            linetop = Number(linetop);
                                            linetop = linetop - 24.5;
                                            linetop = linetop - 7;
                                            line1.style.top = linetop + "%";
                                        } else {
                                            line1.style.zIndex = -1;
                                        }

                                    }
                                } else {

                                    for (var lineCount = 1; lineCount <= songLinecount; lineCount++) {

                                        var line1 = this.getElementById("line_" + lineCount);
                                        line1.style.display = "inline";
                                        if (lineNumber == lineCount) {
                                            line1.style.zIndex = 3;
                                            line1.style.color = "black";
                                            var linetop = line1.getAttribute('data-top');
                                            linetop = Number(linetop);
                                            line1.style.top = linetop + "%";
                                        } else if (lineNumber + 1 == lineCount) {
                                            line1.style.zIndex = 3;
                                            line1.style.color = "#B2AFAD";
                                            var linetop = line1.getAttribute('data-top');
                                            linetop = Number(linetop);
                                            linetop = linetop + 10;
                                            line1.style.top = linetop + "%";
                                        } else if (lineNumber + 2 == lineCount) {
                                            line1.style.zIndex = 3;
                                            line1.style.color = "#B2AFAD";
                                            var linetop = line1.getAttribute('data-top');
                                            linetop = Number(linetop);
                                            linetop = linetop + 20;
                                            line1.style.top = linetop + "%";
                                        } else if (lineNumber - 1 == lineCount) {
                                            line1.style.zIndex = 3;
                                            line1.style.color = "#B2AFAD";
                                            var linetop = line1.getAttribute('data-top');
                                            linetop = Number(linetop);
                                            linetop = linetop - 10;
                                            line1.style.top = linetop + "%";
                                        } else {
                                            line1.style.zIndex = -1;
                                        }

                                    }
                                }
                            } else {


                                for (var lineCount = 1; lineCount <= songLinecount; lineCount++) {

                                    var line1 = this.getElementById("line_" + lineCount);
                                    line1.style.display = "inline";
                                    if (lineNumber == lineCount) {
                                        line1.style.zIndex = 3;
                                        line1.style.color = "black";
                                        var linetop = line1.getAttribute('data-top');
                                        linetop = Number(linetop);
                                        line1.style.top = linetop + "%";
                                    } else if (lineNumber + 1 == lineCount) {
                                        line1.style.zIndex = 3;
                                        line1.style.color = "#B2AFAD";
                                        var linetop = line1.getAttribute('data-top');
                                        linetop = Number(linetop);
                                        linetop = linetop + 10;
                                        line1.style.top = linetop + "%";
                                    } else if (lineNumber + 2 == lineCount) {
                                        line1.style.zIndex = 3;
                                        line1.style.color = "#B2AFAD";
                                        var linetop = line1.getAttribute('data-top');
                                        linetop = Number(linetop);
                                        linetop = linetop + 20;
                                        line1.style.top = linetop + "%";
                                    } else if (lineNumber - 1 == lineCount) {
                                        line1.style.zIndex = 3;
                                        line1.style.color = "#B2AFAD";
                                        var linetop = line1.getAttribute('data-top');
                                        linetop = Number(linetop);
                                        linetop = linetop - 10;
                                        line1.style.top = linetop + "%";
                                    } else {
                                        line1.style.zIndex = -1;
                                    }

                                }
                            }
                        }
                    } else {
                        this.resetHighlights();
                        if (this.currentAudioId == 'circle') {
                            $(this).addClass('highlightCircle');
                        } else if (this.currentAudioId == 'point') {
                            $(this).addClass('highlight');
                        } else {
                            $(this).addClass('highlight');
                        }
                    }

                }
              
            });
            break;

        case 2:
            break;

        default:
            break;
    }

}

resetHighlights() {

  this.customService.removeClass(".highlight","highlight");
  this.customService.removeClass(".highlightCircle","highlightCircle");   
}

audioOverlay(popupid) {

    var audioPlayerElement:any = this.getElementById($("#jquery_jplayer_1 audio")[0].id);
    audioPlayerElement.style.display = "inline";
    audioPlayerElement.style.zIndex = 4;

    var audioPlayer:any = this.getElementById("audioPlayer");
    audioPlayer.style.display = "inline";
    audioPlayer.style.zIndex = 4;

    $('.playButton').css('z-index', 2);
    $('.' + popupid).css('z-index', 4);
    this.showImage(popupid);
    var propTop = this.getComputedStyleValue(popupid, "top");
    var topValue = (parseInt(propTop.replace("px", "")) + 30) + "px";

    if (popupid == "popup2") {
        $('.playButton').css('z-index', 2);
        $('.' + popupid).css('z-index', 2);
    }


    this.getElementById('divOverlay').style.zIndex = 3;
}

getComputedStyleValue(elementId, property) {
    var element = document.getElementById(elementId),
        style = window.getComputedStyle(element);
    return style.getPropertyValue(property);
}

clsAudio() {

    var txtbgColor = document.getElementById("txtbgColor");
    if (txtbgColor != null) {
        this.getElementById('txtbgColor').style.zIndex = -1;
        var dataset_left = txtbgColor.getAttribute('data-left');
        if (dataset_left != undefined) {
            this.getElementById('txtbgColor').style.left = txtbgColor.getAttribute('data-left');
            this.getElementById('txtbgColor').style.width = txtbgColor.getAttribute('data-width');
        }

        $('.songText').css('z-index', -1);
        this.customService.removeClass(".songText","animated");        
        var popup1:any = document.getElementById("popup1");
        popup1.src = popup1.getAttribute('data-imgurl');

        var lineCount:any = txtbgColor.getAttribute('data-seektimestart');
        lineCount = Number(lineCount);
        for (var count = 1; count <= lineCount; count++) {
            var line1 = this.getElementById("line_" + count);
            line1.style.top = line1.getAttribute('data-top') + "%";
            line1.style.display = "none";
        }

    }
    var audioPlayerElement = this.getElementById($("#jquery_jplayer_1 audio")[0].id);
    audioPlayerElement.style.display = "none";
    audioPlayerElement.pause();
    audioPlayerElement.currentTime = 0;
    audioPlayerElement.src = "";
    audioPlayerElement.style.zIndex = 2;
    $("#jplayer_total_time").html("00:00");
    $('.playButton').css('z-index', 2);


    this.customService.removeClass(".label","active");
    this.customService.removeClass(".label_img","active");
    this.getElementById('divOverlay').style.zIndex = -1;

    var audioPlayer = this.getElementById("audioPlayer");
    audioPlayer.style.display = "none";
    audioPlayer.style.zIndex = -1;
}

showpopup_open(){
    this.mouseclick = 1;
 this.customService.addClass("#mainContent", "popup_open");
}
  closepopup_close() {
    this.customService.removeClass("#mainContent", "popup_open"); 
}

showImage(event) {
  let thisme:any=this;

  let id=event.currentTarget.id;
  this.customService.addClass("#mainContent","image_popup_open");  
  var el = this.getElementById(id);
  this.customService.addClass("#"+id,"image_popup_open");


  if (el.className != "popup clicked") {   
    var elements:any = document.getElementsByClassName('popup');
    
    var highestZIndex = 2;
    for (var i = 0; i < elements.length; i++) {
      var zIndex = parseInt(elements[i].style.zIndex);
      if (zIndex > highestZIndex) {
        highestZIndex = zIndex;
      }

    }
    if (el.getAttribute('data-top') != "") {
    
    }
  
    var menubar = localStorage.getItem('leftmenu');
    if (menubar == "invisible") {
      this.customService.addClass("#"+id,"leftmenuhidden");
      
    } else {
      this.customService.addClass("#mainContent","image_popup_open");    
    }
    this.customService.addClass("#"+id,"clicked");

    var closeBtn = this.getElementById('closeBtn');
    this.customService.setAttribute("#closeBtn","popupid",id);
  }
  else { }
}


closePopup(event) {

  this.customService.removeClass("#mainContent","image_popup_open");
 
    this.resetHighlights();

    var closeBtn = this.getElementById('closeBtn');
    var closeBtn_id= closeBtn.getAttribute("popupid");

    var menubar = localStorage.getItem('leftmenu');
    if (menubar == "invisible") {
      this.customService.removeClass("#"+closeBtn_id,"leftmenuhidden");
        
    } else {
      
    }
    this.customService.removeClass("#"+closeBtn_id,"clicked");

    var audioPlayerElement = $("#jquery_jplayer_1 audio");
    if (audioPlayerElement.length != 0) {
        this.clsAudio();
        $("#jquery_jplayer_1").jPlayer("destroy");
    }
}

}
